export type HighlightPart = { text: string; match: boolean };

const MIN_WORD_LENGTH = 2;
// The register matches words shorter than this only as whole words.
const WHOLE_WORD_BELOW = 3;

const LATIN_WORD_CHAR = /[0-9a-zÀ-ɏ]/i;
const LATIN_NON_WORD_RUN = /[^0-9a-zÀ-ɏ]+/i;
const LATIN_LETTER = /[a-zÀ-ɏ]/i;
const COMBINING_MARKS = /[̀-ͯ]/g;

const fold = (text: string) => text.normalize('NFD').replace(COMBINING_MARKS, '').toLowerCase();

const isWordChar = (char: string | undefined) => !!char && LATIN_WORD_CHAR.test(char);

function queryWords(query: string) {
  return fold(query)
    .split(LATIN_NON_WORD_RUN)
    .filter(word => word.length >= MIN_WORD_LENGTH && LATIN_LETTER.test(word));
}

export function highlight(name: string, query: string): HighlightPart[] {
  const chars = Array.from(name);
  let folded = '';
  const charAt: number[] = [];
  chars.forEach((char, i) => {
    const foldedChar = fold(char);
    for (let unit = 0; unit < foldedChar.length; unit++) charAt.push(i);
    folded += foldedChar;
  });

  const hit = chars.map(() => false);
  for (const word of queryWords(query)) {
    for (let at = folded.indexOf(word); at !== -1; at = folded.indexOf(word, at + 1)) {
      const end = at + word.length;
      const standsAlone = !isWordChar(folded[at - 1]) && !isWordChar(folded[end]);
      if (word.length < WHOLE_WORD_BELOW && !standsAlone) continue;
      for (let unit = at; unit < end; unit++) hit[charAt[unit]] = true;
    }
  }

  const parts: HighlightPart[] = [];
  chars.forEach((char, i) => {
    const last = parts[parts.length - 1];
    if (last && last.match === hit[i]) last.text += char;
    else parts.push({ text: char, match: hit[i] });
  });
  return parts;
}

export function townName(city: string | null): string {
  if (!city) return '';
  return city
    .toLocaleLowerCase('sv')
    .replace(
      /(^|[\s-])([^\s-])/g,
      (_, before: string, letter: string) => before + letter.toLocaleUpperCase('sv'),
    );
}
